module.exports = "<div class=\"preloader-wrapper active  {{spinnerType}}\">\r\n    <mdb-Spinners mdbSpinners mode=\"indeterminate\"></mdb-Spinners>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/progressbars/progress-spinner.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/progressbars/progress-spinner.component.html
// module chunks = main